import {
	AccountantListPage,
	AccountantSetupPage,
} from "../../pages/Accountant";
import { DataRoleListPage, DataRoleSetupPage } from "../../pages/DataRole";
import {
	FilingResourceListPage,
	FilingResourceSetupPage,
} from "../../pages/FilingResource";
import {
	RL1SlipListPage,
	RL1SlipSetupPage,
	RL1SlipSummarySetupPage,
} from "../../pages/RL1Slip";
import {
	T4SlipImportPage,
	T4SlipListPage,
	T4SlipSetupPage,
	T4SlipSummaryReducedEISetupPage,
	T4SlipSummarySetupPage,
} from "../../pages/T4Slip";
import { TaxYearListPage, TaxYearSetupPage } from "../../pages/Year";

import { AccountOrBankDetailsPage } from "../../pages/AccountOrBankDetailsPage";
import { AccountSettingsPage } from "../../pages/AddOns/Accounting/AccountSettingsPage";
import { AccountantBankSetupPage } from "../../pages/Accountant/BankSetup";
import { AddOnsCombineSetupPage } from "../../pages/AddOns/Accounting/AddOnsCombineSetupPage";
import { AdminEarningsListPage } from "../../pages/AdminEarningsListPage";
import { AdminEarningsSetupPage } from "../../pages/AdminEarningsSetupPage";
import { BCEHTSettingSetupPage } from "../../pages/BCEHTSettingSetupPage";
import { BankPage } from "../../pages/BankPage";
import { BcEhtSetupPage } from "../../pages/BcEhtSetupPage";
import { BillingProfileAssociationSetupPage } from "../../pages/BillingProfileAssociationSetupPage";
import { BillingProfileSetupPage } from "../../pages/BillingProfileSetupPage/BillingProfileSetupPage";
import { BranchPage } from "../../pages/BranchPage";
import { CRACreditSetupPage } from "../../pages/CRACreditSetupPage";
import { CRADueRemittanceTransacitonsPage } from "../../pages/DirectDeposit/Transactions/CRADueRemittance";
import { CRARamittanceSetupPage } from "../../pages/CRARamittanceSetupPage";
import { CRAReportSetupPage } from "../../pages/reports/CRAReportSetupPage";
import { ChequeSettingsListPage } from "../../pages/ChequeSettingsListPage";
import { ChequeSettingsSetupPage } from "../../pages/ChequeSettingsSetupPage";
import { CityPage } from "../../pages/CityPage";
import { ClientBankSetupPage } from "../../pages/client/clientBankSetupPage";
import { ClientDashboardPage } from "../../pages/client/clientDashboardPage";
import { ClientListPage } from "../../pages/client/clientListPage";
import { ClientSetupPage } from "../../pages/client/clientSetupPage";
import { CollectionUploadedParserPage } from "../../pages/DirectDeposit/Transactions/CollectionUploadedParserPage";
import { CollectionUploadedTransactionsPage } from "../../pages/DirectDeposit/Transactions/CollectionUploaded";
import { CollectionUploadedViewPage } from "../../pages/DirectDeposit/Transactions/CollectionUploadedViewPage";
import { CollectionVoucherListPage } from "../../pages/CollectionVoucherListPage/CollectionVoucherListPage";
import { CollectionVoucherSetupPage } from "../../pages/CollectionVoucherSetupPage/CollectionVoucherSetupPage";
import { CompanyStatutoryHolidayPage } from "../../pages/CompanyStatutoryHolidayPage";
import { CompletedPaymentTransacitonsPage } from "../../pages/DirectDeposit/Transactions/CompletedPayment";
import { ConnectZohoPage } from "../../pages/AddOns/Accounting/ZohoBooks/ConnectZohoPage";
import { CountryListPage } from "../../pages/CountryListPage";
import { CountrySetupPage } from "../../pages/CountrySetupPage";
import { DeductionsListPage } from "../../pages/DeductionsListPage";
import { DeductionsSetupPage } from "../../pages/DeductionsSetupPage";
import { DepartmentsListPage } from "../../pages/DepartmentsListPage";
import { DepartmentsSetupPage } from "../../pages/DepartmentsSetupPage";
import { DesignationListPage } from "../../pages/DesignationListPage";
import { DesignationSetupPage } from "../../pages/DesignationSetupPage";
import { DraftEmployeePage } from "../../pages/DraftEmployeePage";
import { EDRReportPage } from "../../pages/reports/EDRReportPage";
import { EHTOntarioDueRemittanceTransacitonsPage } from "../../pages/DirectDeposit/Transactions/EHTOntarioDueRemittance";
import { EHTOntarioReportPage } from "../../pages/reports/EHTOntarioReportPage";
import { EarningsListPage } from "../../pages/EarningsListPage";
import { EarningsSetupPage } from "../../pages/EarningsSetupPage";
import { EmployeeAssignemntPage } from "../../pages/EmployeeAssignemntPage";
import { EmployeeBankSetupPage } from "../../pages/EmployeeBankSetupPage";
import { EmployeeImportPage } from "../../pages/EmployeeImportPage";
import { EmployeeListPage } from "../../pages/EmployeeListPage";
import { EmployeeReportSetupPage } from "../../pages/reports/EmpolyeeReportSetupPage";
import { EmployeeSetupPage } from "../../pages/EmployeeSetupPage";
import { EmployeeStatusListPage } from "../../pages/EmployeeStatusListPage";
import { EmployeeStatusSetupPage } from "../../pages/EmployeeStatusSetupPage";
import { ErrorTransacitonsPage } from "../../pages/DirectDeposit/Transactions/ErrorTransaction";
import { ExpenseCategoryListPage } from "../../pages/ExpenseCategoryListPage";
import { ExpenseCategorySetupPage } from "../../pages/ExpenseCategorySetupPage";
import { ExportDataPage } from "../../pages/AddOns/Accounting/ExportDataPage";
import { ForgotPasswordPage } from "../../pages/Anonymous/ForgotPasswordPage";
import { GeneralSettingsListPage } from "../../pages/GeneralSettingsListPage";
import { GeneralSettingsSetupPage } from "../../pages/GeneralSettingsSetupPage";
import { GlobalSearchPage } from "../../pages/GlobalSearch";
import { GlobalVariablesPage } from "../../pages/GlobalVariablesPage";
import { IProtectedRouteItem } from "@websential/cosmic-v20";
import { ImportDataPage } from "../../pages/AddOns/Accounting/ImportDataPage";
import { ImportYearToDatePage } from "../../pages/ImportYearToDatePage";
import { InCollectionTransacitonsPage } from "../../pages/DirectDeposit/Transactions/InCollection";
import { InProcessCollectionTransacitonsPage } from "../../pages/DirectDeposit/Transactions/InProcessCollection";
import { InProcessPaymentTransacitonsPage } from "../../pages/DirectDeposit/Transactions/InProcessPayment";
import { InvoiceReportPage } from "../../pages/reports/InvoiceReportPage";
import { InvoiceTransactionDetailPage } from "../../pages/reports/InvoiceTransactionDetail";
import { InvoiceUnchargedTransactionPage } from "../../pages/reports/InvoiceUnchargedTransaction";
import { LoadingPage } from "../../pages/Anonymous/LoadingPage";
import { LocationsListPage } from "../../pages/LocationsListPage";
import { LocationsSetupPage } from "../../pages/LocationsSetupPage";
import { LogoutPage } from "../../pages/Anonymous/LogoutPage";
import { ManageWageAccountPage } from "../../pages/AddOns/Accounting/ManageWageAccountPage";
import { MenuHeadsSetupPage } from "../../pages/RoleManagement/MenuHeadsSetupPage";
import { MinimumWageRatePage } from "../../pages/MinimumWageRatePage";
import { MoveClientPage } from "../../pages/client/MoveClientPage";
import { NewAcocuntSetupPage } from "../../pages/NewAcocuntSetupPage";
import { OffCyclePayrollSetupPage } from "../../pages/OffCyclePayrollSetupPage";
import { OntarioEhtSetupPage } from "../../pages/OntarioEhtSetupPage";
import { PADAgreenment } from "../../components/PADAgreenment";
import { PADAgreenmentPage } from "../../pages/PADAgreenmentPage";
import { PDFAxisPage } from "../../pages/PDFAxisPage";
import { PDFFilesPage } from "../../pages/PDFFilesPage";
import { PaydayAdvancePage } from "../../pages/PaydayAdvancePage";
import { PaydayAdvanceReportPage } from "../../pages/reports/PaydayAdvanceReportPage";
import { PaymentUploadedParserPage } from "../../pages/DirectDeposit/Transactions/PaymentUploadedParserPage";
import { PaymentUploadedTransactionsPage } from "../../pages/DirectDeposit/Transactions/PaymentUploaded";
import { PaymentUploadedViewPage } from "../../pages/DirectDeposit/Transactions/PaymentUploadedViewPage";
import { PaymentVoucherListPage } from "../../pages/PaymentVoucherListPage/PaymentVoucherListPage";
import { PaymentVoucherSetupPage } from "../../pages/PaymentVoucherSetupPage/PaymentVoucherSetupPage";
import { PayrollAdjustmentPage } from "../../pages/PayrollAdjustmentPage";
import { PayrollAdjustmentReportPage } from "../../pages/reports/PayrollAdjustmentReportPage";
import { PayrollCSSTEarningsListPage } from "../../pages/PayrollCSSTEarningListPage";
import { PayrollCSSTEarningsSetupPage } from "../../pages/PayrollCSSTEarningsSetupPage";
import { PayrollEHTEarningsListPage } from "../../pages/PayrollEHTEarningListPage";
import { PayrollEHTEarningsSetupPage } from "../../pages/PayrollEHTEarningsSetupPage";
import { PayrollFederalEarningsListPage } from "../../pages/PayrollFederalEarningListPage/PayrollFederalEarningListPage";
import { PayrollFederalEarningsSetupPage } from "../../pages/PayrollFederalEarningsSetupPage/PayrollFederalEarningsSetupPage";
import { PayrollHSFEarningsListPage } from "../../pages/PayrollHSFEarningListPage";
import { PayrollHSFEarningsSetupPage } from "../../pages/PayrollHSFEarningsSetupPage";
import { PayrollHolidayEarningsListPage } from "../../pages/PayrollHolidayEarningListPage/PayrollHolidayEarningListPage";
import { PayrollHolidayEarningsSetupPage } from "../../pages/PayrollHolidayEarningsSetupPage";
import { PayrollInsurableEarningsListPage } from "../../pages/PayrollInsurableEarningsListPage";
import { PayrollInsurableEarningsSetupPage } from "../../pages/PayrollInsurableEarningsSetupPage/PayrollInsurableEarningsSetupPage";
import { PayrollPensionableEarningsListPage } from "../../pages/PayrollPensionableEarningsListPage";
import { PayrollPensionableEarningsSetupPage } from "../../pages/PayrollPensionableEarningsSetupPage/PayrollPensionableEarningsSetup";
import { PayrollProvincialEarningsListPage } from "../../pages/PayrollProvincialEarningListPage/PayrollProvincialEarningListPage";
import { PayrollProvincialTaxableEarningsSetupPage } from "../../pages/PayrollProvincialTaxableEarningsSetupPage/PayrollProvincialTaxableEarningsSetupPage";
import { PayrollQPIPEarningsListPage } from "../../pages/PayrollQPIPEarningListPage";
import { PayrollQPIPEarningsSetupPage } from "../../pages/PayrollQPIPEarningsSetupPage";
import { PayrollReportSetupPage } from "../../pages/reports/PayrollReportSetupPage";
import { PayrollSchedulePage } from "../../pages/PayrollSchedulePage";
import { PayrollSetupPage } from "../../pages/PayrollSetupPage";
import { PayrollTimeSheetSetupPage } from "../../pages/PayrollTimeSheetSetupPage";
import { PayrollVocationalEarningsListPage } from "../../pages/PayrollVocationalEarningListPage/PayrollVocationalEarningListPage";
import { PayrollVocationalEarningsSetupPage } from "../../pages/PayrollVocationalEarningsSetupPage";
import { PayrollWCBWSIBEarningsListPage } from "../../pages/PayrollWCBWSIBEarningsListPage";
import { PayrollWCBWSIBEarningsSetupPage } from "../../pages/PayrollWCBWSIBEarningsSetupPage/PayrollWCBWSIBEarningsSetupPage";
import { PayrollYearToDatePage } from "../../pages/PayrollYearToDatePage";
import { ProvinceListPage } from "../../pages/ProvinceListPage";
import { ProvinceSetupPage } from "../../pages/ProvinceSetupPage";
import { RL1ReportPage } from "../../pages/reports/RL1ReportPage/RL1ReportPage";
import { RL1SlipImportPage } from "../../pages/RL1Slip/RL1SlipImportPage";
import { RL1SlipImportXmlPage } from "../../pages/RL1Slip/RL1SlipImportXmlPage";
import { RL1SlipSettingsSetupPage } from "../../pages/RL1Slip/RL1SlipSettingsSetupPage";
import { ROEListPage } from "../../pages/ROEListPage";
import { ROEReportPage } from "../../pages/reports/ROEReportPage";
import { ROESetupPage } from "../../pages/ROESetupPage";
import { ROEWebPage } from "../../pages/ROEWebPage";
import { RQDueRemittanceTransacitonsPage } from "../../pages/DirectDeposit/Transactions/RQDueRemittance";
import { RQRamittanceSetupPage } from "../../pages/RQRamittanceSetupPage";
import { RQReportSetupPage } from "../../pages/reports/RQReportSetupPage";
import { ReadyTransacitonsPage } from "../../pages/DirectDeposit/Transactions/Ready";
import { ReimbursementsListPage } from "../../pages/ReimbursementsListPage";
import { ReimbursementsSetupPage } from "../../pages/ReimbursementsSetupPage";
import { RemittanceYearToDatePage } from "../../pages/RemittanceYearToDatePage";
import { RemittedRemittanceTransacitonsPage } from "../../pages/DirectDeposit/Transactions/RemittedRemittance";
import { RolesAssignmentListPage } from "../../pages/RoleManagement/RolesAssignment/List";
import { RolesAssignmentSetupPage } from "../../pages/RoleManagement/RolesAssignment/Setup";
import { RolesListPage } from "../../pages/RoleManagement/Roles/List";
import { RolesSetupPage } from "../../pages/RoleManagement/Roles/Setup";
import { SalaryProfilePage } from "../../pages/SalaryProfilePage";
import { SalaryProfileReportSetupPage } from "../../pages/reports/SalaryProfileReportSetupPage";
import { ScreenPermissionsSetupPage } from "../../pages/RoleManagement/ScreenPermissionsSetupPage";
import { ScreenSetupPage } from "../../pages/RoleManagement/ScreenSetupPage";
import { StateListPage } from "../../pages/StateListPage";
import { StateSetupPage } from "../../pages/StateSetupPage";
import { StatutoryHolidayReportPage } from "../../pages/reports/StatutoryHolidayReportPage";
import { StatutoryHolidaySetupPage } from "../../pages/StatutoryHolidaySetupPage";
import { StubReportPage } from "../../pages/reports/StubReportPage";
import { StubSettingsListPage } from "../../pages/StubSettingsListPage";
import { StubSettingsSetupPage } from "../../pages/StubSettingsSetupPage";
import { SynchronizeEmployeesPage } from "../../pages/AddOns/Accounting/SynchronizeEmployeesPage";
import { T4ReportPage } from "../../pages/reports/T4ReportPage";
import { T4SlipImportXmlPage } from "../../pages/T4Slip/T4SlipImportXMLPage";
import { TD1AdminFormPage } from "../../pages/TD1AdminFormPage";
import { TD1AlbertaFormPage } from "../../pages/ClientTD1FormPage/TD1AlbertaFormPage";
import { TD1FormPage } from "../../pages/ClientTD1FormPage/TD1FormPage";
import { TD1ReportPage } from "../../pages/reports/TD1ReportPage";
import { TaxProfileListPage } from "../../pages/TaxProfileList";
import { TaxProfileSetupPage } from "../../pages/TaxProfileSetup";
import { TeamsListPage } from "../../pages/TeamsListPage";
import { TeamsSetupPage } from "../../pages/TeamsSetupPage";
import { TimeSheetCategoriesPage } from "../../pages/TimeSheetCategoriesPage";
import { TimeSheetCategoryTrackingPage } from "../../pages/TimeSheetCategoryTrackingPage";
import { TimeSheetReportPage } from "../../pages/reports/TimeSheetReportPage";
import { TrustBankListPage } from "../../pages/DirectDeposit/TrustBank/TrustBankList";
import { TrustBankSetupPage } from "../../pages/DirectDeposit/TrustBank/TrustBankSetupPage";
import { UploadDocumentsPage } from "../../pages/UploadDocumentsPage";
import { UsersSetupPage } from "../../pages/RoleManagement/UsersSetupPage";
import { WCBAllProvincesCodeSetupPage } from "../../pages/WCBAllProvincesCodeSetupPage";
import { WCBAllProvincesRemittanceSetupPage } from "../../pages/WCBAllProvincesRemittanceSetupPage";
import { WSIBAssociationListPage } from "../../pages/WSIBAssociationListPage";
import { WSIBAssociationSetupPage } from "../../pages/WSIBAssociationSetupPage";
import { WSIBCategoryListPage } from "../../pages/WSIBCategoryListPage";
import { WSIBCategorySetupPage } from "../../pages/WSIBCategorySetupPage";
import { WSIBClassListPage } from "../../pages/WSIBClassListPage";
import { WSIBClassRateSetupPage } from "../../pages/WSIBClassRateSetupPage";
import { WSIBClassSetupPage } from "../../pages/WSIBClassSetupPage";
import { WSIBCodeListPage } from "../../pages/WSIBCodeListPage";
import { WSIBCodeRateSetupPage } from "../../pages/WSIBCodeRateSetupPage";
import { WSIBCodeSetupPage } from "../../pages/WSIBCodeSetupPage";
import { WSIBMaximumEarningsListPage } from "../../pages/WSIBMaximumEarningsListPage";
import { WSIBMaximumEarningsSetupPage } from "../../pages/WSIBMaximumEarningsSetupPage";
import { WSIBOntarioCodeSetupPage } from "../../pages/WSIBOntarioCodeSetupPage";
import { WSIBOntarioRemittancePage } from "../../pages/WSIBOntarioRemittancePage";
import { WSIBReportPage } from "../../pages/reports/WSIBReportPage";
import { WebROESubmissionPage } from "../../pages/WebROESubmissionPage";
import { WireTransferSetupPage } from "../../pages/WireTransferSetupPage";
import { YearToDateReportPage } from "../../pages/reports/YearToDateReportPage";
import { completedCollectionTransacitonsPage } from "../../pages/DirectDeposit/Transactions/completedCollection";
import { EarningSummaryPage } from "../../pages/EarningSummaryPage";
import { RollBackTransactionsPage } from "../../pages/DirectDeposit/Transactions/RollBackTransactionsPage";
import { NewsSetupPage } from "../../pages/NewsSetupPage";
import { SystemAccessSetupPage } from "../../pages/SystemAccessSetupPage";
import { VacationPayReportPage } from "../../pages/reports/VacationPayReportPage";


// import { TD1AlbertaFormPage } from "../../pages/ClientTD1FormPage/TD1AlbertaFormPage";

// import React from "react";
// const ForgotPasswordPage = React.lazy(() => import("../../pages/Anonymous/ForgotPasswordPage").then(m => ({ default: m.ForgotPasswordPage })));
// const GlobalSearchPage = React.lazy(() => import("../../pages/GlobalSearch").then(m => ({ default: m.GlobalSearchPage })));
// const AccountantListPage = React.lazy(() => import("../../pages/Accountant").then(m => ({ default: m.AccountantListPage })));
// const AccountantSetupPage = React.lazy(() => import("../../pages/Accountant").then(m => ({ default: m.AccountantSetupPage })));
// const LogoutPage = React.lazy(() => import("../../pages/Anonymous/LogoutPage").then(m => ({ default: m.LogoutPage })));
// const EmployeeListPage = React.lazy(() => import("../../pages/EmployeeListPage").then(m => ({ default: m.EmployeeListPage })));
// const EmployeeSetupPage = React.lazy(() => import("../../pages/EmployeeSetupPage").then(m => ({ default: m.EmployeeSetupPage })));
// const ClientDashboardPage = React.lazy(() => import("../../pages/client/clientDashboardPage").then(m => ({ default: m.ClientDashboardPage })));
// const ClientListPage = React.lazy(() => import("../../pages/client/clientListPage").then(m => ({ default: m.ClientListPage })));
// const ClientSetupPage = React.lazy(() => import("../../pages/client/clientSetupPage").then(m => ({ default: m.ClientSetupPage })));
// const AccountantBankSetupPage = React.lazy(() => import("../../pages/Accountant/BankSetup").then(m => ({ default: m.AccountantBankSetupPage })));
// const ClientBankSetupPage = React.lazy(() => import("../../pages/client/clientBankSetupPage").then(m => ({ default: m.ClientBankSetupPage })));
// const MoveClientPage = React.lazy(() => import("../../pages/client/MoveClientPage").then(m => ({ default: m.MoveClientPage })));
// const TeamsListPage = React.lazy(() => import("../../pages/TeamsListPage").then(m => ({ default: m.TeamsListPage })));
// const LocationsListPage = React.lazy(() => import("../../pages/LocationsListPage").then(m => ({ default: m.LocationsListPage })));
// const DesignationListPage = React.lazy(() => import("../../pages/DesignationListPage").then(m => ({ default: m.DesignationListPage })));
// const DepartmentsListPage = React.lazy(() => import("../../pages/DepartmentsListPage").then(m => ({ default: m.DepartmentsListPage })));
// const TeamsSetupPage = React.lazy(() => import("../../pages/TeamsSetupPage").then(m => ({ default: m.TeamsSetupPage })));
// const LocationsSetupPage = React.lazy(() => import("../../pages/LocationsSetupPage").then(m => ({ default: m.LocationsSetupPage })));
// const DesignationSetupPage = React.lazy(() => import("../../pages/DesignationSetupPage").then(m => ({ default: m.DesignationSetupPage })));
// const DepartmentsSetupPage = React.lazy(() => import("../../pages/DepartmentsSetupPage").then(m => ({ default: m.DepartmentsSetupPage })));
// const CountryListPage = React.lazy(() => import("../../pages/CountryListPage").then(m => ({ default: m.CountryListPage })));
// const CountrySetupPage = React.lazy(() => import("../../pages/CountrySetupPage").then(m => ({ default: m.CountrySetupPage })));
// const ProvinceListPage = React.lazy(() => import("../../pages/ProvinceListPage").then(m => ({ default: m.ProvinceListPage })));
// const ProvinceSetupPage = React.lazy(() => import("../../pages/ProvinceSetupPage").then(m => ({ default: m.ProvinceSetupPage })));
// const StateListPage = React.lazy(() => import("../../pages/StateListPage").then(m => ({ default: m.StateListPage })));
// const StateSetupPage = React.lazy(() => import("../../pages/StateSetupPage").then(m => ({ default: m.StateSetupPage })));
// const TaxProfileSetupPage = React.lazy(() => import("../../pages/TaxProfileSetup").then(m => ({ default: m.TaxProfileSetupPage })));
// const TaxProfileListPage = React.lazy(() => import("../../pages/TaxProfileList").then(m => ({ default: m.TaxProfileListPage })));
// const PDFFilesPage = React.lazy(() => import("../../pages/PDFFilesPage").then(m => ({ default: m.PDFFilesPage })));
// const PDFAxisPage = React.lazy(() => import("../../pages/PDFAxisPage").then(m => ({ default: m.PDFAxisPage })));
// const T4SlipImportPage = React.lazy(() => import("../../pages/T4Slip").then(m => ({ default: m.T4SlipImportPage })));
// const T4SlipListPage = React.lazy(() => import("../../pages/T4Slip").then(m => ({ default: m.T4SlipListPage })));
// const T4SlipSetupPage = React.lazy(() => import("../../pages/T4Slip").then(m => ({ default: m.T4SlipSetupPage })));
// const T4SlipSummaryReducedEISetupPage = React.lazy(() => import("../../pages/T4Slip").then(m => ({ default: m.T4SlipSummaryReducedEISetupPage })));
// const T4SlipSummarySetupPage = React.lazy(() => import("../../pages/T4Slip").then(m => ({ default: m.T4SlipSummarySetupPage })));
// const T4SlipImportXmlPage = React.lazy(() => import("../../pages/T4Slip/T4SlipImportXMLPage").then(m => ({ default: m.T4SlipImportXmlPage })));
// const RL1SlipListPage = React.lazy(() => import("../../pages/RL1Slip").then(m => ({ default: m.RL1SlipListPage })));
// const RL1SlipSetupPage = React.lazy(() => import("../../pages/RL1Slip").then(m => ({ default: m.RL1SlipSetupPage })));
// const RL1SlipSummarySetupPage = React.lazy(() => import("../../pages/RL1Slip").then(m => ({ default: m.RL1SlipSummarySetupPage })));
// const RL1SlipSettingsSetupPage = React.lazy(() => import("../../pages/RL1Slip/RL1SlipSettingsSetupPage").then(m => ({ default: m.RL1SlipSettingsSetupPage })));
// const RL1SlipImportPage = React.lazy(() => import("../../pages/RL1Slip/RL1SlipImportPage").then(m => ({ default: m.RL1SlipImportPage })));
// const RL1SlipImportXmlPage = React.lazy(() => import("../../pages/RL1Slip/RL1SlipImportXmlPage").then(m => ({ default: m.RL1SlipImportXmlPage })));
// const EmployeeStatusListPage = React.lazy(() => import("../../pages/EmployeeStatusListPage").then(m => ({ default: m.EmployeeStatusListPage })));
// const EmployeeStatusSetupPage = React.lazy(() => import("../../pages/EmployeeStatusSetupPage").then(m => ({ default: m.EmployeeStatusSetupPage })));
// const DeductionsListPage = React.lazy(() => import("../../pages/DeductionsListPage").then(m => ({ default: m.DeductionsListPage })));
// const DeductionsSetupPage = React.lazy(() => import("../../pages/DeductionsSetupPage").then(m => ({ default: m.DeductionsSetupPage })));
// const ReimbursementsListPage = React.lazy(() => import("../../pages/ReimbursementsListPage").then(m => ({ default: m.ReimbursementsListPage })));
// const ReimbursementsSetupPage = React.lazy(() => import("../../pages/ReimbursementsSetupPage").then(m => ({ default: m.ReimbursementsSetupPage })));
// const EarningsListPage = React.lazy(() => import("../../pages/EarningsListPage").then(m => ({ default: m.EarningsListPage })));
// const EarningsSetupPage = React.lazy(() => import("../../pages/EarningsSetupPage").then(m => ({ default: m.EarningsSetupPage })));
// const TaxYearListPage = React.lazy(() => import("../../pages/Year").then(m => ({ default: m.TaxYearListPage })));
// const TaxYearSetupPage = React.lazy(() => import("../../pages/Year").then(m => ({ default: m.TaxYearSetupPage })));
// const DataRoleListPage = React.lazy(() => import("../../pages/DataRole").then(m => ({ default: m.DataRoleListPage })));
// const DataRoleSetupPage = React.lazy(() => import("../../pages/DataRole").then(m => ({ default: m.DataRoleSetupPage })));
// const EmployeeAssignemntPage = React.lazy(() => import("../../pages/EmployeeAssignemntPage").then(m => ({ default: m.EmployeeAssignemntPage })));
// const ExpenseCategorySetupPage = React.lazy(() => import("../../pages/ExpenseCategorySetupPage").then(m => ({ default: m.ExpenseCategorySetupPage })));
// const ExpenseCategoryListPage = React.lazy(() => import("../../pages/ExpenseCategoryListPage").then(m => ({ default: m.ExpenseCategoryListPage })));
// const FilingResourceListPage = React.lazy(() => import("../../pages/FilingResource").then(m => ({ default: m.FilingResourceListPage })));
// const FilingResourceSetupPage = React.lazy(() => import("../../pages/FilingResource").then(m => ({ default: m.FilingResourceSetupPage })));
// const GeneralSettingsListPage = React.lazy(() => import("../../pages/GeneralSettingsListPage").then(m => ({ default: m.GeneralSettingsListPage })));
// const GeneralSettingsSetupPage = React.lazy(() => import("../../pages/GeneralSettingsSetupPage").then(m => ({ default: m.GeneralSettingsSetupPage })));
// const StubSettingsListPage = React.lazy(() => import("../../pages/StubSettingsListPage").then(m => ({ default: m.StubSettingsListPage })));
// const StubSettingsSetupPage = React.lazy(() => import("../../pages/StubSettingsSetupPage").then(m => ({ default: m.StubSettingsSetupPage })));
// const ChequeSettingsListPage = React.lazy(() => import("../../pages/ChequeSettingsListPage").then(m => ({ default: m.ChequeSettingsListPage })));
// const ChequeSettingsSetupPage = React.lazy(() => import("../../pages/ChequeSettingsSetupPage").then(m => ({ default: m.ChequeSettingsSetupPage })));
// const TD1AdminFormPage = React.lazy(() => import("../../pages/TD1AdminFormPage").then(m => ({ default: m.TD1AdminFormPage })));
// const EmployeeImportPage = React.lazy(() => import("../../pages/EmployeeImportPage").then(m => ({ default: m.EmployeeImportPage })));
// const DraftEmployeePage = React.lazy(() => import("../../pages/DraftEmployeePage").then(m => ({ default: m.DraftEmployeePage })));
// const BankPage = React.lazy(() => import("../../pages/BankPage").then(m => ({ default: m.BankPage })));
// const CityPage = React.lazy(() => import("../../pages/CityPage").then(m => ({ default: m.CityPage })));
// const BranchPage = React.lazy(() => import("../../pages/BranchPage").then(m => ({ default: m.BranchPage })));
// const MinimumWageRatePage = React.lazy(() => import("../../pages/MinimumWageRatePage").then(m => ({ default: m.MinimumWageRatePage })));
// const PaydayAdvancePage = React.lazy(() => import("../../pages/PaydayAdvancePage").then(m => ({ default: m.PaydayAdvancePage })));

export const clientDashboardInitialRoutes: IProtectedRouteItem[] = [
	{
		path: "/",
		// component:DashboardPage,
		component: ClientDashboardPage,
		exact: true,
	},
];
export const clientSetupDashboardInitialRoutes: IProtectedRouteItem[] = [
	{
		path: "/",
		// component:DashboardPage,
		component: ClientSetupPage,
		exact: true,
	},
];

export const superUserInitialClientListRoutes: IProtectedRouteItem[] = [
	{
		path: "/",
		// component:DashboardPage,
		component: ClientListPage,
		exact: true,
	},
];
export const superUserInitialAccountantSetupRoutes: IProtectedRouteItem[] = [
	{
		path: "/",
		// component:DashboardPage,
		component: AccountantSetupPage,
		exact: true,
	},
];
export const AccountiungProfessionalInitialRoutes: IProtectedRouteItem[] = [
	{
		path: "/",
		// component:DashboardPage,
		component: AccountOrBankDetailsPage,
		exact: true,
	},
];
export const AccountiungProfessionalPADInitialRoutes: IProtectedRouteItem[] = [
	{
		path: "/",
		// component:DashboardPage,
		component: PADAgreenmentPage,
		exact: true,
	},
];
export const AccountiungProfessionalUDInitialRoutes: IProtectedRouteItem[] = [
	{
		path: "/",
		// component:DashboardPage,
		component: UploadDocumentsPage,
		exact: true,
	},
];
export const SingleCompanyInitialRoutes: IProtectedRouteItem[] = [
	{
		path: "/",
		// component:DashboardPage,
		component: NewAcocuntSetupPage,
		exact: true,
	},
];

export const nonSuperUserInitialRoutes: IProtectedRouteItem[] = [
	{
		path: "/",
		// component:DashboardPage,
		component: ClientListPage,
		exact: true,
	},
];

export const nonSuperUserInitialRoutesIfAccAssign: IProtectedRouteItem[] = [
	{
		path: "/",
		// component:DashboardPage,
		component: AccountantListPage,
		exact: true,
	},
];

export const initialLoadingPageWhileMenuIsGettingFromAPI: IProtectedRouteItem[] =
	[
		{
			path: "/",
			// component:ClientDashboardPage,
			component: LoadingPage,
			exact: true,
		},
	];
export const routes: IProtectedRouteItem[] = [
	{
		path: "/",
		// component:ClientDashboardPage,
		component: GlobalSearchPage,
		exact: true,
	},
];
export const GlobalSearchRoutes: IProtectedRouteItem[] = [
	{
		path: "/",
		component: GlobalSearchPage,
		exact: true,
	},
	{
		path: "*",
		component: LogoutPage,
		exact: true,
	},
];
export const ForgetPasswordRoutes: IProtectedRouteItem[] = [
	{
		path: "/",
		component: ForgotPasswordPage,
		exact: true,
	},
	{
		path: "/:key",
		component: ForgotPasswordPage,
		exact: true,
	},
];

export const AccountantsRoutes: IProtectedRouteItem[] = [
	{
		path: "/",
		component: AccountantListPage,
		exact: true,
	},
	{
		path: "list",
		component: AccountantListPage,
		exact: true,
	},
	{
		path: "setup",
		component: AccountantSetupPage,
		exact: true,
	},
	{
		path: "setup/:id",
		component: AccountantSetupPage,
		exact: true,
	},
	{
		path: "bank-setup",
		component: AccountantBankSetupPage,
		exact: true,
	},
	{
		path: "bank-setup/:id",
		component: AccountantBankSetupPage,
		exact: true,
	},
	{
		path: "clients",
		component: ClientListPage,
		exact: true,
	},
	// {
	//   path: "move-clients",
	//   component: MoveClientListPage,
	//   exact: true,
	// },
	// {
	//   path: "/client-adjustment-report",
	//   component: ClientAdjustmentReportPage,
	//   exact: true,
	// },
	{
		path: "*",
		component: LogoutPage,
		exact: true,
	},
];
export const DirectDepositRoutes: IProtectedRouteItem[] = [
	{
		path: "/trust-bank/list",
		component: TrustBankListPage,
		exact: true,
	},
	{
		path: "/trust-bank/setup",
		component: TrustBankSetupPage,
		exact: true,
	},
	{
		path: "/trust-bank/setup/:id",
		component: TrustBankSetupPage,
		exact: true,
	},
	{
		path: "/transactions/ready",
		component: ReadyTransacitonsPage,
		exact: true,
	},
	{
		path: "/transactions/in-process-collection",
		component: InProcessCollectionTransacitonsPage,
		exact: true,
	},
	{
		path: "/transactions/in-collection",
		component: InCollectionTransacitonsPage,
		exact: true,
	},
	{
		path: "/transactions/collection-uploaded",
		component: CollectionUploadedTransactionsPage,
		exact: true,
	},
	{
		path: "/transactions/collection-uploaded/parser/:id",
		component: CollectionUploadedParserPage,
		exact: true,
	},
	{
		path: "/transactions/collection-uploaded/view/:id",
		component: CollectionUploadedViewPage,
		exact: true,
	},
	{
		path: "/transactions/completed-collection",
		component: completedCollectionTransacitonsPage,
		exact: true,
	},
	{
		path: "/transactions/completed-payment",
		component: CompletedPaymentTransacitonsPage,
		exact: true,
	},
	{
		path: "/transactions/payment-uploaded",
		component: PaymentUploadedTransactionsPage,
		exact: true,
	},

	{
		path: "/transactions/payment-uploaded/parser/:id",
		component: PaymentUploadedParserPage,
		exact: true,
	},
	{
		path: "/transactions/payment-uploaded/view/:id",
		component: PaymentUploadedViewPage,
		exact: true,
	},

	{
		path: "/transactions/in-process-payment",
		component: InProcessPaymentTransacitonsPage,
		exact: true,
	},
	{
		path: "/transactions/remittance/cra-due",
		component: CRADueRemittanceTransacitonsPage,
		exact: true,
	},
	{
		path: "/transactions/remittance/rq-due",
		component: RQDueRemittanceTransacitonsPage,
		exact: true,
	},
	{
		path: "/transactions/remittance/eht-ontario-due",
		component: EHTOntarioDueRemittanceTransacitonsPage,
		exact: true,
	},
	{
		path: "/transactions/remittance/remitted",
		component: RemittedRemittanceTransacitonsPage,
		exact: true,
	},
	{
		path: "/transactions/error",
		component: ErrorTransacitonsPage,
		exact: true,
	},
	{
		path: "/transactions/rollback",
		component: RollBackTransactionsPage,
		exact: true,
	},
	{
		path: "*",
		component: LogoutPage,
		exact: true,
	},
];
export const WorkplaceSafetyRoutes: IProtectedRouteItem[] = [
	{
		path: "/class/list",
		component: WSIBClassListPage,
		exact: true,
	},
	{
		path: "/class/setup",
		component: WSIBClassSetupPage,
		exact: true,
	},
	{
		path: "/class/setup/:id",
		component: WSIBClassSetupPage,
		exact: true,
	},
	{
		path: "/category/list",
		component: WSIBCategoryListPage,
		exact: true,
	},
	{
		path: "/category/setup",
		component: WSIBCategorySetupPage,
		exact: true,
	},
	{
		path: "/category/setup/:id",
		component: WSIBCategorySetupPage,
		exact: true,
	},
	{
		path: "/code/list",
		component: WSIBCodeListPage,
		exact: true,
	},
	{
		path: "/code/setup",
		component: WSIBCodeSetupPage,
		exact: true,
	},
	{
		path: "/code/setup/:id",
		component: WSIBCodeSetupPage,
		exact: true,
	},
	{
		path: "/association/list",
		component: WSIBAssociationListPage,
		exact: true,
	},
	{
		path: "/association/setup",
		component: WSIBAssociationSetupPage,
		exact: true,
	},
	{
		path: "/association/setup/:id",
		component: WSIBAssociationSetupPage,
		exact: true,
	},
	{
		path: "/maximum-earnings/list",
		component: WSIBMaximumEarningsListPage,
		exact: true,
	},
	{
		path: "/maximum-earnings/setup",
		component: WSIBMaximumEarningsSetupPage,
		exact: true,
	},
	{
		path: "/maximum-earnings/setup/:id",
		component: WSIBMaximumEarningsSetupPage,
		exact: true,
	},
	{
		path: "/class-rate/setup",
		component: WSIBClassRateSetupPage,
		exact: true,
	},
	{
		path: "/class-rate/setup/:id",
		component: WSIBClassRateSetupPage,
		exact: true,
	},

	{
		path: "/code-rate/setup",
		component: WSIBCodeRateSetupPage,
		exact: true,
	},
	{
		path: "/code-rate/setup/:id",
		component: WSIBCodeRateSetupPage,
		exact: true,
	},

	{
		path: "*",
		component: LogoutPage,
		exact: true,
	},
];

export const CountryRoutes: IProtectedRouteItem[] = [
	{
		path: "/",
		component: CountryListPage,
		exact: true,
	},
	{
		path: "list",
		component: CountryListPage,
		exact: true,
	},
	{
		path: "setup",
		component: CountrySetupPage,
		exact: true,
	},
	{
		path: "setup/:id",
		component: CountrySetupPage,
		exact: true,
	},
	{
		path: "*",
		component: LogoutPage,
		exact: true,
	},
];
export const ProvinceRoutes: IProtectedRouteItem[] = [
	{
		path: "/",
		component: ProvinceListPage,
		exact: true,
	},
	{
		path: "list",
		component: ProvinceListPage,
		exact: true,
	},
	{
		path: "setup",
		component: ProvinceSetupPage,
		exact: true,
	},
	{
		path: "setup/:id",
		component: ProvinceSetupPage,
		exact: true,
	},
	{
		path: "*",
		component: LogoutPage,
		exact: true,
	},
];
export const StateRoutes: IProtectedRouteItem[] = [
	{
		path: "/",
		component: StateListPage,
		exact: true,
	},
	{
		path: "list",
		component: StateListPage,
		exact: true,
	},
	{
		path: "setup",
		component: StateSetupPage,
		exact: true,
	},
	{
		path: "setup/:id",
		component: StateSetupPage,
		exact: true,
	},
	{
		path: "*",
		component: LogoutPage,
		exact: true,
	},
];
export const TaxProfileRoutes: IProtectedRouteItem[] = [
	{
		path: "/",
		component: TaxProfileListPage,
		exact: true,
	},
	{
		path: "list",
		component: TaxProfileListPage,
		exact: true,
	},
	{
		path: "setup",
		component: TaxProfileSetupPage,
		exact: true,
	},
	{
		path: "setup/:id",
		component: TaxProfileSetupPage,
		exact: true,
	},
	{
		path: "*",
		component: LogoutPage,
		exact: true,
	},
];
export const TaxYearRoutes: IProtectedRouteItem[] = [
	{
		path: "/",
		component: TaxYearListPage,
		exact: true,
	},
	{
		path: "list",
		component: TaxYearListPage,
		exact: true,
	},
	{
		path: "setup",
		component: TaxYearSetupPage,
		exact: true,
	},
	{
		path: "setup/:id",
		component: TaxYearSetupPage,
		exact: true,
	},
	{
		path: "*",
		component: LogoutPage,
		exact: true,
	},
];
export const DataRoleRoutes: IProtectedRouteItem[] = [
	{
		path: "/",
		component: DataRoleListPage,
		exact: true,
	},
	{
		path: "list",
		component: DataRoleListPage,
		exact: true,
	},
	{
		path: "setup",
		component: DataRoleSetupPage,
		exact: true,
	},
	{
		path: "setup/:id",
		component: DataRoleSetupPage,
		exact: true,
	},
	{
		path: "*",
		component: LogoutPage,
		exact: true,
	},
];

export const PDFSettingsRoutes: IProtectedRouteItem[] = [
	{
		path: "pdf-files",
		component: PDFFilesPage,
		exact: true,
	},
	{
		path: "pdf-axis",
		component: PDFAxisPage,
		exact: true,
	},
	{
		path: "*",
		component: LogoutPage,
		exact: true,
	},
];

export const TD1FormRoutes: IProtectedRouteItem[] = [
	{
		path: "/admin/td1",
		component: TD1AdminFormPage,
		exact: true,
	},
	{
		path: "/admin/td1/:id",
		component: TD1AdminFormPage,
		exact: true,
	},
	{
		path: "*",
		component: LogoutPage,
		exact: true,
	},
];

export const BankRoutes: IProtectedRouteItem[] = [
	{
		path: "/",
		component: BankPage,
		exact: true,
	},
	{
		path: "/:id",
		component: BankPage,
		exact: true,
	},
	{
		path: "*",
		component: LogoutPage,
		exact: true,
	},
];
export const CityRoutes: IProtectedRouteItem[] = [
	{
		path: "/",
		component: CityPage,
		exact: true,
	},
	{
		path: "/:id",
		component: CityPage,
		exact: true,
	},
	{
		path: "*",
		component: CityPage,
		exact: true,
	},
];
export const BranchRoutes: IProtectedRouteItem[] = [
	{
		path: "/",
		component: BranchPage,
		exact: true,
	},
	{
		path: "/:id",
		component: BranchPage,
		exact: true,
	},
	{
		path: "*",
		component: LogoutPage,
		exact: true,
	},
];
export const MinimumWageRateRoutes: IProtectedRouteItem[] = [
	{
		path: "/",
		component: MinimumWageRatePage,
		exact: true,
	},
	{
		path: "/:id",
		component: MinimumWageRatePage,
		exact: true,
	},
	{
		path: "*",
		component: LogoutPage,
		exact: true,
	},
];

export const NewsRoutes: IProtectedRouteItem[] = [
	{
		path: "/",
		component: NewsSetupPage,
		exact: true,
	},
	{
		path: "/:id",
		component: NewsSetupPage,
		exact: true,
	},
	{
		path: "*",
		component: LogoutPage,
		exact: true,
	},
];

export const WebROESubmissionRoutes: IProtectedRouteItem[] = [
	{
		path: "/",
		component: WebROESubmissionPage,
		exact: true,
	},
	{
		path: "*",
		component: LogoutPage,
		exact: true,
	},
];

export const RoleManagementRoutes: IProtectedRouteItem[] = [
	{
		path: "/menu-heads",
		component: MenuHeadsSetupPage,
		exact: true,
	},
	{
		path: "/menu-heads/:id",
		component: MenuHeadsSetupPage,
		exact: true,
	},
	{
		path: "/screen",
		component: ScreenSetupPage,
		exact: true,
	},
	{
		path: "/screen/:id",
		component: ScreenSetupPage,
		exact: true,
	},
	{
		path: "/screen-permissions",
		component: ScreenPermissionsSetupPage,
		exact: true,
	},
	{
		path: "/screen-permissions/:id",
		component: ScreenPermissionsSetupPage,
		exact: true,
	},
	{
		path: "/users",
		component: UsersSetupPage,
		exact: true,
	},
	{
		path: "/users/:id",
		component: UsersSetupPage,
		exact: true,
	},
	{
		path: "/role",
		component: RolesListPage,
		exact: true,
	},
	{
		path: "/role/setup",
		component: RolesSetupPage,
		exact: true,
	},
	{
		path: "/role/setup/:id",
		component: RolesSetupPage,
		exact: true,
	},
	{
		path: "/role-assignment",
		component: RolesAssignmentListPage,
		exact: true,
	},
	{
		path: "/role-assignment/setup",
		component: RolesAssignmentSetupPage,
		exact: true,
	},
	{
		path: "/role/setup-assignment/:id",
		component: RolesAssignmentSetupPage,
		exact: true,
	},
	{
		path: "*",
		component: LogoutPage,
		exact: true,
	},
];

export const StatutoryHolidayRoutes: IProtectedRouteItem[] = [
	{
		path: "/",
		component: StatutoryHolidaySetupPage,
		exact: true,
	},
	{
		path: "/:id",
		component: StatutoryHolidaySetupPage,
		exact: true,
	},
	{
		path: "*",
		component: LogoutPage,
		exact: true,
	},
];

export const BCEHTSettingRoutes: IProtectedRouteItem[] = [
	{
		path: "/",
		component: BCEHTSettingSetupPage,
		exact: true,
	},
	{
		path: "/:id",
		component: BCEHTSettingSetupPage,
		exact: true,
	},
	{
		path: "*",
		component: LogoutPage,
		exact: true,
	},
];

export const BillingProfileRoutes: IProtectedRouteItem[] = [
	{
		path: "/",
		component: BillingProfileSetupPage,
		exact: true,
	},
	{
		path: "/:id",
		component: BillingProfileSetupPage,
		exact: true,
	},
	{
		path: "*",
		component: LogoutPage,
		exact: true,
	},
];

export const BillingProfileAssociationRoutes: IProtectedRouteItem[] = [
	{
		path: "/",
		component: BillingProfileAssociationSetupPage,
		exact: true,
	},
	{
		path: "/:id",
		component: BillingProfileAssociationSetupPage,
		exact: true,
	},
	{
		path: "*",
		component: LogoutPage,
		exact: true,
	},
];

export const VouchersRoutes: IProtectedRouteItem[] = [
	{
		path: "/collection/list",
		component: CollectionVoucherListPage,
		exact: true,
	},
	{
		path: "/collection/setup",
		component: CollectionVoucherSetupPage,
		exact: true,
	},
	{
		path: "/collection/setup/:id",
		component: CollectionVoucherSetupPage,
		exact: true,
	},
	{
		path: "/payment/list",
		component: PaymentVoucherListPage,
		exact: true,
	},
	{
		path: "/payment/setup",
		component: PaymentVoucherSetupPage,
		exact: true,
	},
	{
		path: "/payment/setup/:id",
		component: PaymentVoucherSetupPage,
		exact: true,
	},
	{
		path: "*",
		component: LogoutPage,
		exact: true,
	},
];

export const ClientRoutes: IProtectedRouteItem[] = [
	{
		path: "/",
		component: ClientListPage,
		exact: true,
	},
	{
		path: "list",
		component: ClientListPage,
		exact: true,
	},
	{
		path: "setup",
		component: ClientSetupPage,
		exact: true,
	},
	{
		path: "setup/:id",
		component: ClientSetupPage,
		exact: true,
	},
	{
		path: "bank-setup",
		component: ClientBankSetupPage,
		exact: true,
	},
	{
		path: "bank-setup/:id",
		component: ClientBankSetupPage,
		exact: true,
	},
	{
		path: "move-clients",
		component: MoveClientPage,
		exact: true,
	},
	{
		path: "dashboard",
		component: ClientDashboardPage,
		exact: true,
	},
	{
		path: "*",
		component: LogoutPage,
		exact: true,
	},
];
export const EmployeeRoutes: IProtectedRouteItem[] = [
	{
		path: "/list",
		component: EmployeeListPage,
		exact: true,
	},
	{
		path: "/setup",
		component: EmployeeSetupPage,
		exact: true,
	},
	{
		path: "/setup/:id",
		component: EmployeeSetupPage,
		exact: true,
	},
	// {
	// 	path: "/status/list",
	// 	component: EmployeeStatusListPage,
	// 	exact: true,
	// },
	// {
	// 	path: "/status/setup",
	// 	component: EmployeeStatusSetupPage,
	// 	exact: true,
	// },
	// {
	// 	path: "/status/setup/:id",
	// 	component: EmployeeStatusSetupPage,
	// 	exact: true,
	// },
	{
		path: "/status",
		component: EmployeeStatusSetupPage,
		exact: true,
	},
	{
		path: "/status/:id",
		component: EmployeeStatusSetupPage,
		exact: true,
	},
	{
		path: "/assignment",
		component: EmployeeAssignemntPage,
		exact: true,
	},
	{
		path: "/assignment/:id",
		component: EmployeeAssignemntPage,
		exact: true,
	},
	{
		path: "/import",
		component: EmployeeImportPage,
		exact: true,
	},
	{
		path: "/draft",
		component: DraftEmployeePage,
		exact: true,
	},
	{
		path: "/payday-advance",
		component: PaydayAdvancePage,
		exact: true,
	},
	{
		path: "/payday-advance/:id",
		component: PaydayAdvancePage,
		exact: true,
	},
	{
		path: "/salary-profile",
		component: SalaryProfilePage,
		exact: true,
	},
	{
		path: "/salary-profile/:id",
		component: SalaryProfilePage,
		exact: true,
	},
	{
		path: "/bank-setup",
		component: EmployeeBankSetupPage,
		exact: true,
	},
	{
		path: "/bank-setup/:id",
		component: EmployeeBankSetupPage,
		exact: true,
	},
];
export const PayrollRoutes: IProtectedRouteItem[] = [
	{
		path: "/",
		component: PayrollSetupPage,
		exact: true,
	},
	{
		path: "/:id",
		component: PayrollSetupPage,
		exact: true,
	},
	{
		path: "/adjustment",
		component: PayrollAdjustmentPage,
		exact: true,
	},
	{
		path: "/adjustment/:id",
		component: PayrollAdjustmentPage,
		exact: true,
	},
	{
		path: "/off-cycle",
		component: OffCyclePayrollSetupPage,
		exact: true,
	},
	{
		path: "/off-cycle/:id",
		component: OffCyclePayrollSetupPage,
		exact: true,
	},
	{
		path: "/timesheet",
		component: PayrollTimeSheetSetupPage,
		exact: true,
	},
	{
		path: "/timesheet/:id",
		component: PayrollTimeSheetSetupPage,
		exact: true,
	},
	{
		path: "/wire-transfer",
		component: WireTransferSetupPage,
		exact: true,
	},
	{
		path: "/wire-transfer/:id",
		component: WireTransferSetupPage,
		exact: true,
	},
	{
		path: "/earning-summary",
		component: EarningSummaryPage,
		exact: true,
	},
	{
		path: "/earning-summary/:id",
		component: EarningSummaryPage,
		exact: true,
	},
];
export const CompanyRoutes: IProtectedRouteItem[] = [
	// {
	// 	path: "setup",
	// 	component: ClientSetupPage,
	// 	exact: true,
	// },
	{
		path: "/clients/setup/:id",
		component: ClientSetupPage,
		exact: true,
	},
	{
		path: "/clients/bank-setup",
		component: ClientBankSetupPage,
		exact: true,
	},
	{
		path: "/payroll-schedule",
		component: PayrollSchedulePage,
		exact: true,
	},
	{
		path: "/payroll-schedule/:id",
		component: PayrollSchedulePage,
		exact: true,
	},
	{
		path: "/filing-resources/list",
		component: FilingResourceListPage,
		exact: true,
	},
	{
		path: "/filing-resources/setup",
		component: FilingResourceSetupPage,
		exact: true,
	},
	{
		path: "/filing-resources/setup/:id",
		component: FilingResourceSetupPage,
		exact: true,
	},
	{
		path: "/teams/list",
		component: TeamsListPage,
		exact: true,
	},
	{
		path: "/teams/setup",
		component: TeamsSetupPage,
		exact: true,
	},
	{
		path: "/teams/setup/:id",
		component: TeamsSetupPage,
		exact: true,
	},
	{
		path: "/locations/list",
		component: LocationsListPage,
		exact: true,
	},
	{
		path: "/locations/setup",
		component: LocationsSetupPage,
		exact: true,
	},
	{
		path: "/locations/setup/:id",
		component: LocationsSetupPage,
		exact: true,
	},
	{
		path: "/designation/list",
		component: DesignationListPage,
		exact: true,
	},
	{
		path: "/designation/setup",
		component: DesignationSetupPage,
		exact: true,
	},
	{
		path: "/designation/setup/:id",
		component: DesignationSetupPage,
		exact: true,
	},
	{
		path: "/departments/list",
		component: DepartmentsListPage,
		exact: true,
	},
	{
		path: "/departments/setup",
		component: DepartmentsSetupPage,
		exact: true,
	},
	{
		path: "/departments/setup/:id",
		component: DepartmentsSetupPage,
		exact: true,
	},
	{
		path: "/expense-category/list",
		component: ExpenseCategoryListPage,
		exact: true,
	},
	{
		path: "/expense-category/setup",
		component: ExpenseCategorySetupPage,
		exact: true,
	},
	{
		path: "/expense-category/setup/:id",
		component: ExpenseCategorySetupPage,
		exact: true,
	},
	{
		path: "/deductions/list",
		component: DeductionsListPage,
		exact: true,
	},
	{
		path: "/deductions/setup",
		component: DeductionsSetupPage,
		exact: true,
	},
	{
		path: "/deductions/setup/:id",
		component: DeductionsSetupPage,
		exact: true,
	},
	{
		path: "/reimbursements/list",
		component: ReimbursementsListPage,
		exact: true,
	},
	{
		path: "/reimbursements/setup",
		component: ReimbursementsSetupPage,
		exact: true,
	},
	{
		path: "/reimbursements/setup/:id",
		component: ReimbursementsSetupPage,
		exact: true,
	},
	{
		path: "/earnings/list",
		component: EarningsListPage,
		exact: true,
	},
	{
		path: "/earnings/setup",
		component: EarningsSetupPage,
		exact: true,
	},
	{
		path: "/earnings/setup/:id",
		component: EarningsSetupPage,
		exact: true,
	},
];

export const ComplianceRoutes: IProtectedRouteItem[] = [
	{
		path: "t4/list",
		component: T4SlipListPage,
		exact: true,
	},
	{
		path: "t4/setup",
		component: T4SlipSetupPage,
		exact: true,
	},
	{
		path: "t4/setup/:id",
		component: T4SlipSetupPage,
		exact: true,
	},
	{
		path: "t4/summary",
		component: T4SlipSummarySetupPage,
		exact: true,
	},
	{
		path: "t4/summary-reduced-ei",
		component: T4SlipSummaryReducedEISetupPage,
		exact: true,
	},
	{
		path: "t4/import",
		component: T4SlipImportPage,
		exact: true,
	},
	{
		path: "t4/import-xml",
		component: T4SlipImportXmlPage,
		exact: true,
	},
	{
		path: "rl1/list",
		component: RL1SlipListPage,
		exact: true,
	},
	{
		path: "rl1/setup",
		component: RL1SlipSetupPage,
		exact: true,
	},
	{
		path: "rl1/setup/:id",
		component: RL1SlipSetupPage,
		exact: true,
	},
	{
		path: "rl1/summary",
		component: RL1SlipSummarySetupPage,
		exact: true,
	},
	{
		path: "rl1/settings",
		component: RL1SlipSettingsSetupPage,
		exact: true,
	},
	{
		path: "rl1/import",
		component: RL1SlipImportPage,
		exact: true,
	},
	{
		path: "rl1/import-xml",
		component: RL1SlipImportXmlPage,
		exact: true,
	},
	{
		path: "/roe/setup",
		component: ROESetupPage,
		exact: true,
	},
	{
		path: "/roe/setup/:id",
		component: ROESetupPage,
		exact: true,
	},
	{
		path: "/roe/list",
		component: ROEListPage,
		exact: true,
	},
	{
		path: "/roe/list/:id",
		component: ROEListPage,
		exact: true,
	},
	{
		path: "/roe/web",
		component: ROEWebPage,
		exact: true,
	},
	// {
	// 	path: "/td1/federal",
	// 	component: TD1FormPage,
	// 	exact: true,
	// },
	// {
	// 	path: "/td1/alberta",
	// 	component: TD1AlbertaFormPage,
	// 	exact: true,
	// },
	{
		path: "*",
		component: LogoutPage,
		exact: true,
	},
];

export const TD1Routes: IProtectedRouteItem[] = [
	{
		path: ":td1FormName",
		component: TD1FormPage,
		exact: true,
	},
	{
		path: ":td1FormName/:id",
		component: TD1FormPage,
		exact: true,
	},
	// 	{
	// 	path: ":td1FormName/",
	// 	component: TD1FormPage,
	// 	exact: true,
	// },

	// {
	// 	path: ":td1FormName/:id",
	// 	component: TD1FormPage,
	// 	exact: true,
	// },
];
export const ReportsRoutes: IProtectedRouteItem[] = [
	{
		path: "employee/setup",
		component: EmployeeReportSetupPage,
		exact: true,
	},
	{
		path: "compliance/t4",
		component: T4ReportPage,
		exact: true,
	},
	{
		path: "compliance/rl1",
		component: RL1ReportPage,
		exact: true,
	},
	{
		path: "compliance/td1",
		component: TD1ReportPage,
		exact: true,
	},
	{
		path: "salary",
		component: SalaryProfileReportSetupPage,
		exact: true,
	},
	{
		path: "eht-ontario",
		component: EHTOntarioReportPage,
		exact: true,
	},
	{
		path: "cra",
		component: CRAReportSetupPage,
		exact: true,
	},
	{
		path: "rq",
		component: RQReportSetupPage,
		exact: true,
	},
	{
		path: "edr",
		component: EDRReportPage,
		exact: true,
	},
	{
		path: "/invoice",
		component: InvoiceReportPage,
		exact: true,
	},
	{
		path: "/invoice/transaction-detail",
		component: InvoiceTransactionDetailPage,
		exact: true,
	},
	{
		path: "/invoice/uncharged-transactions",
		component: InvoiceUnchargedTransactionPage,
		exact: true,
	},
	{
		path: "payroll",
		component: PayrollReportSetupPage,
		exact: true,
	},
	{
		path: "stub",
		component: StubReportPage,
		exact: true,
	},
	{
		path: "payday-advance",
		component: PaydayAdvanceReportPage,
		exact: true,
	},
	{
		path: "year-to-date",
		component: YearToDateReportPage,
		exact: true,
	},
	{
		path: "payroll-adjustment",
		component: PayrollAdjustmentReportPage,
		exact: true,
	},
	{
		path: "compliance/roe",
		component: ROEReportPage,
		exact: true,
	},
	{
		path: "wsib",
		component: WSIBReportPage,
		exact: true,
	},
	{
		path: "timesheet",
		component: TimeSheetReportPage,
		exact: true,
	},
	{
		path: "statutory-holiday",
		component: StatutoryHolidayReportPage,
		exact: true,
	},
	{
		path: "vacation-pay",
		component: VacationPayReportPage,
		exact: true,
	},
];

export const AddOnsRoutes: IProtectedRouteItem[] = [
	{
		path: "account-settings/:AccountSettingsPageName",
		component: AccountSettingsPage,
		exact: true,
	},
	{
		path: "account-settings/:AccountSettingsPageName/:id",
		component: AccountSettingsPage,
		exact: true,
	},
	{
		path: "connect-zoho/:ConnectZohoPageName",
		component: ConnectZohoPage,
		exact: true,
	},
	{
		path: "connect-zoho/:ConnectZohoPageName/:id",
		component: ConnectZohoPage,
		exact: true,
	},
	// {
	//   path: "zoho-books/connect-zoho",
	//   component: ConnectZohoPage,
	//   exact: true,
	// },
	// {
	//   path: "zoho-books/connect-zoho/:id",
	//   component: ConnectZohoPage,
	//   exact: true,
	// },
	{
		path: "net-suite/synchronize-employees",
		component: SynchronizeEmployeesPage,
		exact: true,
	},
	{
		path: "net-suite/synchronize-employees/:id",
		component: SynchronizeEmployeesPage,
		exact: true,
	},

	{
		path: "export-data/:ExportDataPageName",
		component: ExportDataPage,
		exact: true,
	},
	{
		path: "export-data/:ExportDataPageName/:id",
		component: ExportDataPage,
		exact: true,
	},
	{
		path: "import-data/:ImportDataPageName",
		component: ImportDataPage,
		exact: true,
	},
	{
		path: "import-data/:ImportDataPageName/:id",
		component: ImportDataPage,
		exact: true,
	},
	{
		path: "setup/:AddOnsCombineSetupPageName",
		component: AddOnsCombineSetupPage,
		exact: true,
	},
	{
		path: "setup/:AddOnsCombineSetupPageName/:id",
		component: AddOnsCombineSetupPage,
		exact: true,
	},

	{
		path: "manage-wage-account/:ManageWageAccountPageName",
		component: ManageWageAccountPage,
		exact: true,
	},
	{
		path: "manage-wage-account/:ManageWageAccountPageName/:id",
		component: ManageWageAccountPage,
		exact: true,
	},
];

export const SettingsRoutes: IProtectedRouteItem[] = [
	{
		path: "general/list",
		component: GeneralSettingsListPage,
		exact: true,
	},
	{
		path: "general/setup",
		component: GeneralSettingsSetupPage,
		exact: true,
	},
	{
		path: "general/setup/:id",
		component: GeneralSettingsSetupPage,
		exact: true,
	},
	{
		path: "stub/list",
		component: StubSettingsListPage,
		exact: true,
	},
	{
		path: "stub/setup",
		component: StubSettingsSetupPage,
		exact: true,
	},
	{
		path: "stub/setup/:id",
		component: StubSettingsSetupPage,
		exact: true,
	},
	{
		path: "cheque/list",
		component: ChequeSettingsListPage,
		exact: true,
	},
	{
		path: "cheque/setup",
		component: ChequeSettingsSetupPage,
		exact: true,
	},
	{
		path: "cheque/setup/:id",
		component: ChequeSettingsSetupPage,
		exact: true,
	},
	{
		path: "/statutory-holiday",
		component: CompanyStatutoryHolidayPage,
		exact: true,
	},
	{
		path: "/statutory-holiday/:id",
		component: CompanyStatutoryHolidayPage,
		exact: true,
	},
	{
		path: "/year-to-date/payroll",
		component: PayrollYearToDatePage,
		exact: true,
	},
	{
		path: "/year-to-date/import",
		component: ImportYearToDatePage,
		exact: true,
	},
	{
		path: "/year-to-date/remittance",
		component: RemittanceYearToDatePage,
		exact: true,
	},
	{
		path: "/year-to-date/remittance/:id",
		component: RemittanceYearToDatePage,
		exact: true,
	},
	{
		path: "/timesheet/category",
		component: TimeSheetCategoriesPage,
		exact: true,
	},
	{
		path: "/timesheet/category/:id",
		component: TimeSheetCategoriesPage,
		exact: true,
	},
	{
		path: "/timesheet/category-tracking",
		component: TimeSheetCategoryTrackingPage,
		exact: true,
	},
	{
		path: "/timesheet/category-tracking/:id",
		component: TimeSheetCategoryTrackingPage,
		exact: true,
	},
	{
		path: "system-access",
		component: SystemAccessSetupPage,
		exact: true,
	},
	{
		path: "*",
		component: LogoutPage,
		exact: true,
	},
];

export const GlobalVariablesRoutes: IProtectedRouteItem[] = [
	{
		path: "/",
		component: GlobalVariablesPage,
		exact: true,
	},
	{
		path: "/:id",
		component: GlobalVariablesPage,
		exact: true,
	},
	{
		path: "*",
		component: LogoutPage,
		exact: true,
	},
];

export const PayrollEarningsRoutes: IProtectedRouteItem[] = [
	{
		path: "/list",
		component: AdminEarningsListPage,
		exact: true,
	},
	{
		path: "/setup",
		component: AdminEarningsSetupPage,
		exact: true,
	},
	{
		path: "/setup/:id",
		component: AdminEarningsSetupPage,
		exact: true,
	},
];
export const PayrollFederalEarningsRoutes: IProtectedRouteItem[] = [
	{
		path: "/list",
		component: PayrollFederalEarningsListPage,
		exact: true,
	},
	{
		path: "/setup",
		component: PayrollFederalEarningsSetupPage,
		exact: true,
	},
	{
		path: "/setup/:id",
		component: PayrollFederalEarningsSetupPage,
		exact: true,
	},
];

export const PayrollInsurableEarningsRoutes: IProtectedRouteItem[] = [
	{
		path: "/list",
		component: PayrollInsurableEarningsListPage,
		exact: true,
	},
	{
		path: "/setup",
		component: PayrollInsurableEarningsSetupPage,
		exact: true,
	},
	{
		path: "/setup/:id",
		component: PayrollInsurableEarningsSetupPage,
		exact: true,
	},
];
export const PayrollPensionableEarningsRoutes: IProtectedRouteItem[] = [
	{
		path: "/list",
		component: PayrollPensionableEarningsListPage,
		exact: true,
	},
	{
		path: "/setup",
		component: PayrollPensionableEarningsSetupPage,
		exact: true,
	},
	{
		path: "/setup/:id",
		component: PayrollPensionableEarningsSetupPage,
		exact: true,
	},
];

export const PayrollWCBWSIBEarningsRoutes: IProtectedRouteItem[] = [
	{
		path: "/list",
		component: PayrollWCBWSIBEarningsListPage,
		exact: true,
	},
	{
		path: "/setup",
		component: PayrollWCBWSIBEarningsSetupPage,
		exact: true,
	},
	{
		path: "/setup/:id",
		component: PayrollWCBWSIBEarningsSetupPage,
		exact: true,
	},
];

export const PayrollProvincialTaxableEarningsRoutes: IProtectedRouteItem[] = [
	{
		path: "/list",
		component: PayrollProvincialEarningsListPage,
		exact: true,
	},
	{
		path: "/setup",
		component: PayrollProvincialTaxableEarningsSetupPage,
		exact: true,
	},
	{
		path: "/setup/:id",
		component: PayrollProvincialTaxableEarningsSetupPage,
		exact: true,
	},
];

export const PayrollVocationalEarningsRoutes: IProtectedRouteItem[] = [
	{
		path: "/list",
		component: PayrollVocationalEarningsListPage,
		exact: true,
	},
	{
		path: "/setup",
		component: PayrollVocationalEarningsSetupPage,
		exact: true,
	},
	{
		path: "/setup/:id",
		component: PayrollVocationalEarningsSetupPage,
		exact: true,
	},
];

export const PayrollHolidayEarningsRoutes: IProtectedRouteItem[] = [
	{
		path: "/list",
		component: PayrollHolidayEarningsListPage,
		exact: true,
	},
	{
		path: "/setup",
		component: PayrollHolidayEarningsSetupPage,
		exact: true,
	},
	{
		path: "/setup/:id",
		component: PayrollHolidayEarningsSetupPage,
		exact: true,
	},
];

export const PayrollQPIPEarningsRoutes: IProtectedRouteItem[] = [
	{
		path: "/list",
		component: PayrollQPIPEarningsListPage,
		exact: true,
	},
	{
		path: "/setup",
		component: PayrollQPIPEarningsSetupPage,
		exact: true,
	},
	{
		path: "/setup/:id",
		component: PayrollQPIPEarningsSetupPage,
		exact: true,
	},
];

export const PayrollCSSTEarningsRoutes: IProtectedRouteItem[] = [
	{
		path: "/list",
		component: PayrollCSSTEarningsListPage,
		exact: true,
	},
	{
		path: "/setup",
		component: PayrollCSSTEarningsSetupPage,
		exact: true,
	},
	{
		path: "/setup/:id",
		component: PayrollCSSTEarningsSetupPage,
		exact: true,
	},
];

export const PayrollHSFEarningsRoutes: IProtectedRouteItem[] = [
	{
		path: "/list",
		component: PayrollHSFEarningsListPage,
		exact: true,
	},
	{
		path: "/setup",
		component: PayrollHSFEarningsSetupPage,
		exact: true,
	},
	{
		path: "/setup/:id",
		component: PayrollHSFEarningsSetupPage,
		exact: true,
	},
];

export const PayrollEHTEarningsRoutes: IProtectedRouteItem[] = [
	{
		path: "/list",
		component: PayrollEHTEarningsListPage,
		exact: true,
	},
	{
		path: "/setup",
		component: PayrollEHTEarningsSetupPage,
		exact: true,
	},
	{
		path: "/setup/:id",
		component: PayrollEHTEarningsSetupPage,
		exact: true,
	},
];
export const TaxesRoutes: IProtectedRouteItem[] = [
	{
		path: "remittance/cra",
		component: CRARamittanceSetupPage,
		exact: true,
	},
	{
		path: "remittance/cra-credit",
		component: CRACreditSetupPage,
		exact: true,
	},
	{
		path: "remittance/cra-credit/:id",
		component: CRACreditSetupPage,
		exact: true,
	},
	{
		path: "remittance/rq",
		component: RQRamittanceSetupPage,
		exact: true,
	},
	{
		path: "eht/bc_eht",
		component: BcEhtSetupPage,
		exact: true,
	},
	{
		path: "eht/bc_eht/:id",
		component: BcEhtSetupPage,
		exact: true,
	},
	{
		path: "eht/ontario",
		component: OntarioEhtSetupPage,
		exact: true,
	},
	{
		path: "eht/ontario/:id",
		component: OntarioEhtSetupPage,
		exact: true,
	},
	{
		path: "wsib/ontario-code/setup",
		component: WSIBOntarioCodeSetupPage,
		exact: true,
	},
	{
		path: "wsib/ontario-code/setup/:id",
		component: WSIBOntarioCodeSetupPage,
		exact: true,
	},
	{
		path: "wsib/ontario-remittance",
		component: WSIBOntarioRemittancePage,
		exact: true,
	},
	{
		path: "wcb/code/:wcbProvinceName",
		component: WCBAllProvincesCodeSetupPage,
		exact: true,
	},
	{
		path: "wcb/code/:wcbProvinceName/:id",
		component: WCBAllProvincesCodeSetupPage,
		exact: true,
	},
	{
		path: "wcb/remittance/:wcbProvinceName",
		component: WCBAllProvincesRemittanceSetupPage,
		exact: true,
	},
	{
		path: "wcb/remittance/:wcbProvinceName/:id",
		component: WCBAllProvincesRemittanceSetupPage,
		exact: true,
	},

	{
		path: "*",
		component: LogoutPage,
		exact: true,
	},
];
